import { Component } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { LoadingService } from 'src/app/loading.service';
import { BlogPost } from '../blog-post';
import { BlogService } from '../blog.service';
import { blogPostValidator } from './blog-validation.directive';

@Component({
  selector: 'app-new-blog-post',
  templateUrl: './new-blog-post.component.html',
  styleUrls: ['./new-blog-post.component.css']
})
export class NewBlogPostComponent {

  constructor(private formBuilder: FormBuilder, private blogPostsService: BlogService, private loadingService: LoadingService) {}

  selectedFile?: File = undefined
  fileName = '';

  blogPostForm = this.formBuilder.group({
    title: [''],
    content: [''],
    author: [''],
  }, {validators: blogPostValidator})

  onSubmit() {
    const date = new Date()
    const newBlogPost = ({uid: undefined, title: this.blogPostForm.value.title, content: this.blogPostForm.value.content, date: date, author: this.blogPostForm.value.author }) as BlogPost
    const loadingKey = newBlogPost.title
    this.loadingService.addLoadingKey(loadingKey)
    this.blogPostsService.addNewBlogPost(newBlogPost, loadingKey, this.selectedFile)
  }

  cancelClicked() {
    this.blogPostsService.addBlogPostCancelled()
  }

  onFileSelected(event: any) {
    const file: File = event.target.files[0];
    if (file) {
      if (file.type == "image/png" || file.type == "image/jpeg") {
        this.fileName = file.name;
        this.selectedFile = file
      } else {
        alert(`Error: Invalid File Type - ${file.name}`)
        return
      }
    }
  }

  removeFile() {
    this.selectedFile = undefined
    this.fileName = ""
  }

}
